export const FETCH_CHECK_STATUS_REQUEST = 'api/FETCH_CHECK_STATUS_REQUEST';
export const FETCH_CHECK_STATUS_SUCCESS = 'api/FETCH_CHECK_STATUS_SUCCESS';
export const FETCH_CHECK_STATUS_FAILURE = 'api/FETCH_CHECK_STATUS_FAILURE';

export const FETCH_IDENTITY_STATUS_REQUEST = 'api/FETCH_IDENTITY_STATUS_REQUEST';
export const FETCH_IDENTITY_STATUS_SUCCESS = 'api/FETCH_IDENTITY_STATUS_SUCCESS';
export const FETCH_IDENTITY_STATUS_FAILURE = 'api/FETCH_IDENTITY_STATUS_FAILURE';

export const FETCH_SET_ACCOUNT_REQUEST = 'api/FETCH_SET_ACCOUNT_REQUEST';
export const FETCH_SET_ACCOUNT_SUCCESS = 'api/FETCH_SET_ACCOUNT_SUCCESS';
export const FETCH_SET_ACCOUNT_FAILURE = 'api/FETCH_SET_ACCOUNT_FAILURE';

export const FETCH_STATUS_REQUEST = 'api/FETCH_STATUS_REQUEST';
export const FETCH_STATUS_SUCCESS = 'api/FETCH_STATUS_SUCCESS';
export const FETCH_STATUS_FAILURE = 'api/FETCH_STATUS_FAILURE';

export const FETCH_FORM_REQUEST = 'api/FETCH_FORM_REQUEST';
export const FETCH_FORM_SUCCESS = 'api/FETCH_FORM_SUCCESS';
export const FETCH_FORM_FAILURE = 'api/FETCH_FORM_FAILURE';

export const FETCH_ENVIRONMENT_REQUEST = 'api/FETCH_ENVIRONMENT_REQUEST';
export const FETCH_ENVIRONMENT_SUCCESS = 'api/FETCH_ENVIRONMENT_SUCCESS';
export const FETCH_ENVIRONMENT_FAILURE = 'api/FETCH_ENVIRONMENT_FAILURE';

export const FETCH_API_VERSION_REQUEST = 'api/FETCH_API_VERSION_REQUEST';
export const FETCH_API_VERSION_SUCCESS = 'api/FETCH_API_VERSION_SUCCESS';
export const FETCH_API_VERSION_FAILURE = 'api/FETCH_API_VERSION_FAILURE';

export const FETCH_SERVER_TIME_REQUEST = 'api/FETCH_SERVER_TIME_REQUEST';
export const FETCH_SERVER_TIME_SUCCESS = 'api/FETCH_SERVER_TIME_SUCCESS';
export const FETCH_SERVER_TIME_FAILURE = 'api/FETCH_SERVER_TIME_FAILURE';

export const FETCH_INSTITUTION_ADDRESSES_REQUEST = 'api/FETCH_INSTITUTION_ADDRESSES_REQUEST';
export const FETCH_INSTITUTION_ADDRESSES_SUCCESS = 'api/FETCH_INSTITUTION_ADDRESSES_SUCCESS';
export const FETCH_INSTITUTION_ADDRESSES_FAILURE = 'api/FETCH_INSTITUTION_ADDRESSES_FAILURE';

export const FETCH_INSTITUTION_NAMES_REQUEST = 'api/FETCH_INSTITUTION_NAMES_REQUEST';
export const FETCH_INSTITUTION_NAMES_SUCCESS = 'api/FETCH_INSTITUTION_NAMES_SUCCESS';
export const FETCH_INSTITUTION_NAMES_FAILURE = 'api/FETCH_INSTITUTION_NAMES_FAILURE';

export const FETCH_INSTITUTION_SEARCH_REQUEST = 'api/FETCH_INSTITUTION_SEARCH_REQUEST';
export const FETCH_INSTITUTION_SEARCH_SUCCESS = 'api/FETCH_INSTITUTION_SEARCH_SUCCESS';
export const FETCH_INSTITUTION_SEARCH_FAILURE = 'api/FETCH_INSTITUTION_SEARCH_FAILURE';

export const FETCH_ANNOUNCEMENTS_REQUEST = 'api/FETCH_ANNOUNCEMENTS_REQUEST';
export const FETCH_ANNOUNCEMENTS_SUCCESS = 'api/FETCH_ANNOUNCEMENTS_SUCCESS';
export const FETCH_ANNOUNCEMENTS_FAILURE = 'api/FETCH_ANNOUNCEMENTS_FAILURE';

export const SUBMIT_IDENTITY_VERIFICATION_REQUEST = 'api/SUBMIT_IDENTITY_VERIFICATION_REQUEST';
export const SUBMIT_IDENTITY_VERIFICATION_SUCCESS = 'api/SUBMIT_IDENTITY_VERIFICATION_SUCCESS';
export const SUBMIT_IDENTITY_VERIFICATION_FAILURE = 'api/SUBMIT_IDENTITY_VERIFICATION_FAILURE';
